<template>
  <div class="appbar-container">
    <div v-if="bannerShow" class="banner">
      <img class="banner-logo" src="../assets/header/richgo_mobile_logo.png"/>
      <span class="vertical-split"></span>
      <div class="banner-title">
        <div>"내 아파트의 미래가격은?" 리치고 모바일 앱(무료!)이 출시 되었습니다.</div>
        <span class="goto-richgom" @click="gotoRichgom">부동산 리치고 바로가기 ></span>
      </div>
      <!-- <div class=banner-close @click="() => {console.log('d')}">         -->
      <div class=banner-close @click="onBannerClose">
        <img src="../assets/header/close.svg"/>
      </div>
    </div>

    <div class="sns-and-login">
      <div class="sns">
        <ul>
          <li @click="gotoYoutube">
            <img src="../assets/header/sns_utube.svg"/>
            <span style="margin-left:4px">리치고 유튜브</span>
          </li>
          <span class="vertical-split2"></span>
          <li @click="gotoFacebook">
            <img src="../assets/header/sns_facebook.svg"/>
            <span style="margin-left:4px">리치고 페이스북</span>
          </li>
        </ul>
      </div>
<!--      b2b-->
      <router-link v-if="profile && profile.isHyundai" tag="div" to="/hyundai" class="hyundai">
        <img src="../assets/b2b/hyundai/ci_hyundai.svg">
      </router-link>
      <router-link v-if="profile && profile.isDlcon" tag="div" to="/dlcon" class="dlcon">
        <img src="../assets/b2b/dlcon/ci_dlcon.png">
      </router-link>
<!--      -->
      <div class="right-menu">
        <router-link tag="div" to="/pricing" class="pricing" v-on:click.native="setMenuShow(false)">요금안내</router-link>
        <div class="pricing" @click="onCustomerService">고객센터</div>
        <router-link tag="div" v-if="!isLoggedin" to="/login" class="login" v-on:click.native="setMenuShow(false)">로그인/회원가입</router-link>
        <div v-else class="logged-in">
          <router-link tag="div" to="/profile" class="profile" v-on:click.native="setMenuShow(false)">회원 정보</router-link>
          <div @click="onLogout" class="logout">로그아웃</div>
        </div>
      </div>
    </div>

    <div class="menu">
      <div class="menu1">
        <ul>
          <router-link tag="li" to="/service">서비스 소개</router-link>
          <li @click="gotoConsulting">부동산 상담</li>
          <li @click="gotoGuide">사용방법 안내</li>
        </ul>
      </div>
      <router-link tag="div" to="/" class="logo" v-on:click.native="setMenuShow(false)">
        <img class="richgo-big-logo" src="../assets/header/richgo_expert_logo.svg"/>
        <img class="richgo-small-logo" src="../assets/header/richgo_expert_logo.svg"/>
      </router-link>
      <div class="menu2">
        <ul>
          <li @click="onMenuClick('/realestate')">부동산 리치고</li>
          <li @click="onMenuClick('/economy')">경제 리치고</li>
        </ul>
      </div>
      <div @click="toggleMenuButton" class="menu-button">
        <img v-if="!menuShow" src="../assets/header/menu.svg">
        <img v-else src="../assets/header/menu_close.svg"/>
      </div>
      <div v-if="menuShow" class="mobile-menu">
        <div class="mobile-menu-background"></div>
        <ul>
          <router-link tag="li" to="/service" v-on:click.native="setMenuShow(false)">서비스 소개</router-link>
          <li @click="gotoConsulting">부동산 상담</li>
          <li @click="gotoGuide">사용방법 안내</li>
          <li @click="onMenuClick('/realestate')">부동산 리치고</li>
          <li @click="onMenuClick('economy')">경제 리치고</li>
          <router-link tag="li" to="/pricing" class="pricing" v-on:click.native="setMenuShow(false)">요금안내</router-link>
          <li @click="onCustomerService">고객센터</li>
        </ul>
        <div class="mobile-richgom-container">
          <div class="mobile-richgom">
            <img class="mobile-richgom-logo" src="../assets/header/richgo_mobile_logo.png"/>
            <div class="mobile-richgom-title">"내 아파트의 미래가격은?"<br/>리치고 모바일 앱(무료!)이 출시 되었습니다.</div>
            <div class="mobile-richgom-link" @click="gotoRichgom">부동산 리치고 바로가기 ></div>
          </div>
        </div>
        <div class="mobile-sns">
          <div @click="gotoYoutube">
            <img src="../assets/header/sns_utube.svg"/>
            <span>리치고 유튜브</span>
          </div>
          <div @click="gotoFacebook">
            <img src="../assets/header/sns_facebook.svg"/>
            <span>리치고 페이스북</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="menuShow" class="mobile-login-container">
      <router-link tag="div" v-if="!isLoggedin" to="/login" class="login" v-on:click.native="setMenuShow(false)">로그인/회원가입</router-link>
      <div v-else class="logged-in">
        <router-link tag="div" to="/profile" class="profile" v-on:click.native="setMenuShow(false)">회원 정보</router-link>
        <div @click="onLogout" class="logout">로그아웃</div>
      </div>
    </div>


  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";


export default {
  async created() {
    await this.updateLoggedin();
  },
  async updated() {
    await this.updateLoggedin();
  },
  computed: {
    ...mapState(["menuVisible", "menuData", "isLoggedin", "profile"]),
    ...mapFields(["mobileMenu"])
  },
  data() {
    return {
      onMenu: false,
      onSubmenu: false,
      activeSubmenus: {},
      bannerShow: true,
      menuShow: false,
    };
  },
  methods: {
    ...mapMutations(["showMenu", "logout", "showDrawer", "showRichgoMobileBanner"]),
    ...mapActions(["updateLoggedin"]),
    toggleMobileMenu() {
      this.mobileMenu = !this.mobileMenu;
    },
    async onLogout() {
      this.menuShow = false;
      this.logout();
      if (this.$router.currentRoute.path !== "/") {
        this.$router.push("/");
      }
      await this.updateLoggedin();
    },
    onMenuClick(to) {
      this.menuShow = false;
      this.showDrawer(true);
      if (this.$router.currentRoute.path !== to) {
        this.$router.push(to);
      }
    },
    onBannerClose() {
      this.bannerShow = false;
      this.showRichgoMobileBanner(false);
    },
    gotoRichgom() {
      window.open("https://richgo.ai");
      this.menuShow = false;
    },
    gotoYoutube() {
      window.open("https://www.youtube.com/channel/UC3nsb3SxlRrJQ9egkKNnlfg");
      this.menuShow = false;
    },
    gotoFacebook() {
      window.open("https://www.facebook.com/weRichGo");
      this.menuShow = false;
    },
    gotoConsulting() {
      window.open("https://www.richgolab.com");
      this.menuShow = false;
    },
    gotoGuide() {
      window.open('https://dataknows.notion.site/Expert-835e26b0d8784052a6cdc7b5492175df');
      this.menuShow = false;
    },
    toggleMenuButton() {
      this.menuShow = !this.menuShow;
    },
    setMenuShow(v) {
      this.menuShow = v;
    },
    onCustomerService() {
      const url = `https://richgo.channel.io/lounge?name=${this.profile ? this.profile.name : ''}&email=${this.profile ? this.profile.email : ''}&user_id=${this.profile ? this.profile.userId : ''}&service=expert`;
      window.open(url)
      this.menuShow = false;
    }
  }
};
</script>

<style scoped>
.hyundai {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 110px;

}
.hyundai:hover {
  cursor: pointer;
}

.dlcon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 110px;
}

.dlcon:hover {
  cursor: pointer;
}

.dlcon > img {
  width: 140px;
}

.appbar-container {
  padding: 0;
  margin:0;
  cursor: default;
}

.banner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}
.banner-logo {
  height: 32px;
}
.banner-title {
  font-weight: 600;
  font-size: 14px;
}

.vertical-split {
  content: "";
  display: inline-block;
  margin: 0 20px;
  border-left: 1px solid  rgba(41, 46, 669, 0.1);
  width: 2px;
  height: 32px;
  box-sizing: border-box;
}

.vertical-split2 {
  content: "";
  display: inline-block;
  border-left: 1px solid  rgba(255, 255, 255, 0.4);
  width: 2px;
  height: 16px;
  box-sizing: border-box;
}

.mobile-menu {
  display: none;
}

.banner-close {
  margin: 10px 12px;
  position: absolute;
  top: 0;
  right:0;
}

.banner-close:hover {
  cursor: pointer;
}

li {
  cursor: pointer;
}

.goto-richgom {
  color: rgba(49, 130, 246, 1);
  cursor: pointer;
}

.goto-richgom:hover {
  border-bottom: 1px solid rgba(49, 130, 246, 1);
}

.sns-and-login {
  background-color: #F5A21E;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.appbar-container ul {
  padding: 0;
  margin: 0 21px;
}

.appbar-container li {
  list-style: none;
  display: flex;
  align-items: center;
  padding: 0 20px;
}

.sns-and-login {
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 600;
}

.sns-and-login > .sns > ul {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.logged-in {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.logged-in .profile {
  display: flex;
  align-items: center;
  padding: 0;
  line-height: 1;
  margin-right: 15px;
  cursor: pointer;
  color: #4B4541;
  border-bottom: 1px solid #4B4541;
}

.logged-in .logout {
  display: flex;
  align-items: center;
  height: 40px;
  background-color:  #E5780C;
  padding: 0 10px 0 21px;
  cursor: pointer;
}

.right-menu {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #FFFFFF;
  height: 40px;
  margin: 0;
  padding: 0;
}

.right-menu .pricing {
  padding: 0 28px;
  height: 40px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.right-menu .login {
  display: flex;
  align-items: center ;
  height: 40px;
  background-color:  #E5780C;
  padding: 0 10px 0 22px;
  cursor: pointer;
}

.menu {
  background-color: #FFFFFF;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 17px;
  font-weight: 600;
  border-bottom: 1px solid #F2F2F2;
}

.menu1 > ul,
.menu2 > ul {
  margin: 0;
}

.menu ul {
  display: flex;
  justify-content: center;
  align-items: center;
}

.menu li {
  padding: 8px 23px;
}

.menu li:hover {
  cursor: pointer;
}

.menu1,
.menu2 {
  padding: 0;
  margin: 0;
}

.menu .logo {
  cursor: pointer;
  margin: 0 68px;
}

.richgo-small-logo,
.richgo-big-logo {
  display: flex;
  align-items: center;
  justify-content: center;
}

.richgo-small-logo {
  display: none;
  height: 35px;
}

.menu-button {
  display: none;
  cursor: pointer;
}

.mobile-sns {
  display: none;
}

.mobile-login-container {
  display: none;
}

@media only screen and (max-width: 1280px) {
  .menu1 li,
  .menu2 li {
    display: none;
  }

  .menu {
    position: relative;
    border-bottom: 1px solid #F2F2F2;
  }

  .menu-button {
    display: inline-block;
    position: absolute;
    top: 22px;
    right: 18px;
  }

  .mobile-menu {
    display: inline-block;
    margin-top: 23px;
    position: absolute;
    top: 57px;
    right: 0;
    width: 100%;
  }

  .mobile-menu-background {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    background: #FFFFFF;

    width: 100%;
    z-index: -1;
  }

  .mobile-menu ul {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    background-color: #FFFFFF;
  }

  .mobile-menu li {
    font-size: 17px;
    font-weight: 600;
    margin: 10px 0;
    padding: 7px 0;
    position: relative;
  }

  .mobile-menu li:hover::after {
    display: inline-block;
    position: absolute;
    bottom: 0px;
    content: '';
    width: 100%;
    border: 1px solid #4B4541;
    box-sizing: border-box;
  }

  .mobile-menu .pricing {
    display: none;
  }

  .mobile-richgom {
    display: none;
  }
}

@media only screen and (max-width: 980px) {
}

@media only screen and (max-width: 720px) {
  .richgo-small-logo {
    display: flex;
    justify-content: flex-start;
  }

  .richgo-big-logo {
    display: none;
  }

  .menu {
    height: 56px;
  }

  .menu-button {
    top: 10px;
    right: 16px;
  }

  .mobile-menu {
    margin: 0;
  }

  .mobile-menu li {
    padding: 0;
    margin: 0;
    font-size: 17px;
    padding: 18px 0 17px 0;
  }

  .mobile-menu li:hover {
    position: relative;
    border: none;
    box-sizing: border-box;
  }

  .mobile-menu li:hover::after {
    display: inline-block;
    position: absolute;
    bottom: 7px;
    content: '';
    width: 100%;
    border: 1px solid #4B4541;
    box-sizing: border-box;
  }

  .mobile-menu .pricing {
    display: flex;
  }

  .mobile-richgom-container {
    background-color: #FFFFFF;
    padding: 20px 20px 26px;
  }

  .mobile-richgom {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 33px 0 26.5px 0;
    background-color: #F4F4F4;
    border: 1px solid #BCC4E0;
  }

  .mobile-richgom .mobile-richgom-logo {
    margin-bottom: 25px;
    height: 32px;
  }

  .mobile-richgom .mobile-richgom-title {
    font-size: 14px;
    display: flex;
    justify-content: center;
    text-align: center;
    font-weight: 550;
  }

  .mobile-richgom .mobile-richgom-link {
    color: #3182F6;
    font-size: 14px;
    font-weight: 600;
    margin-top: 11px;
    cursor: pointer;
  }

  .mobile-sns {
    background-color: #4B4541;
    color: #FFFFFF;
    width: 100%;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    padding: 20px 16px;
  }

  .mobile-sns div {
    display: flex;
    align-items: center;
    padding: 14px 0;
    cursor: pointer;
  }

  .mobile-sns span {
    padding: 0 4px;
    margin: 0;
  }

  .mobile-menu-background {
    background-color: #4B4541;
  }

  .mobile-login-container {
    display: flex;
    height: 52px;
    background-color:#F5A21E;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 600;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .mobile-login-container .logged-in {
    position: absolute;
    right: 0;
    top: 74px;
  }

  .mobile-login-container .profile {
    color: inherit;
    border-bottom: 1px solid #FFFFFF;
    padding-right: 0;
    margin-right: 0;
  }

  .mobile-login-container .logout {
    background-color: inherit;
    padding: 0;
    margin-right: 20px;
    margin-left: 19px;
    border-bottom: 1px solid #FFFFFF;
    line-height: 1;
    height: 16px;
  }

  .mobile-menu {
    margin-top: 51px;
  }

  .mobile-menu li:nth-child(4),
  .mobile-menu li:nth-child(5) {
    color: #E5780C
  }

  .sns-and-login,
  .banner {
    display: none;
  }
}


</style>
